import { formatCurrencyShort } from "@wrstudios/utils";
import { colors, getStatusColor } from "@wrstudios/theme";
export function getMarkerColor(_a) {
  var statusValue = _a.statusValue,
      isHighlighted = _a.isHighlighted,
      color = _a.color;
  if (color) return color;
  if (isHighlighted) return colors.gray[900];
  return getStatusColor(statusValue);
}
export function getMarkerPrice(price) {
  if (typeof price === "string") return price;
  return formatCurrencyShort(price);
}